import { lang } from "src/language/lang"
import { isset } from "./default"

window.error_count = 0

export const error_handle = async (error, noticeOnly = false) => {
    console.log(error)
    try {
        if (error.response) {
            let log = 'Request fail with status: ' + error.response.status + '. ' + String(error.response.data)
            if (error.response.data instanceof Blob) {
                log = await error.response.data.text()
            } else {
                if(error.response.data.detail){
                    let detail = error.response.data.detail
                    if(typeof detail != 'string'){
                        detail = JSON.stringify(detail, null, 2)
                    }
                    log += " - " + detail
                }
            }

            if (error.response.status == 401 || error.response.status == 403) {
                if (window.isRefreshingToken) return
                let nextLink = window.location.pathname + window.location.search + window.location.hash
                window.location.href = `#/login?log=${lang(log)}&next=${btoa(nextLink)}`
                window.location.reload()
                return
            }

            if (error.response.status == 502) {
                window.error_count++
                if (window.error_count >= 3) {
                    window.error_count = 0
                    window.location.href = `#/error`
                    return
                }
            }

            setTimeout(() => {
                if (noticeOnly) {
                    window.notice(lang(log), 'error')
                } else {
                    window.alert(lang(log))
                }
            }, 100)
            return
        }

        if (isset(error.result)) {
            if (!error.result) {
                setTimeout(() => {
                    if (noticeOnly) {
                        window.notice(lang(error.message), 'error')
                    } else {
                        window.alert(lang(error.message))
                    }
                }, 100)
                return
            }
        }

        if (error.code == "ERR_NETWORK") {
            window.error_count++
            if (window.error_count >= 3) {
                window.error_count = 0
                window.location.href = `#/error`
                return
            }
        }

    } catch (e) {
        console.log(e)
        setTimeout(() => {
            if (noticeOnly) {
                window.notice(lang(e.message), 'error')
            } else {
                window.alert(lang(e.message))
            }
        }, 100)
    }

}